import { render, staticRenderFns } from "./SavedOrders.vue?vue&type=template&id=bacf8984&scoped=true"
import script from "./SavedOrders.vue?vue&type=script&lang=js"
export * from "./SavedOrders.vue?vue&type=script&lang=js"
import style0 from "./SavedOrders.vue?vue&type=style&index=0&id=bacf8984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf8984",
  null
  
)

export default component.exports